<template>
    <div class="processSearchTotal">
        <div class="processSearch">
            <el-row>
                <el-col class="processSearchTotal-search-left">
                    <el-row>
                        <el-col class="sn-search-process-item">
                            <el-input v-model.trim="searchData['barcodeNo']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202101280001', { defaultText: '条码字符串' })"></el-input>
                        </el-col>
                        <el-col class="sn-search-process-item">
                            <el-input trim v-model.trim="searchData['billNos']"  @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202101280002', { defaultText: '单据号' })">
                                <i slot="suffix" class="billNos-title el-icon-question" :data-title="billNosMain"></i>
                            </el-input>
                        </el-col>
                        <el-col class="sn-search-process-item">
                            <el-input trim v-model.trim="searchData['itemCode']" :placeholder="$translate('lang.E3202101280003', { defaultText: '产品编码' })"></el-input>
                        </el-col>
                        <el-col class="sn-search-process-item">
                            <el-input trim v-model.trim="searchData['itemName']" :placeholder="$translate('lang.E3202101280013', { defaultText: '产品名称' })"></el-input>
                        </el-col>
                        <el-col class="sn-search-process-item">
                            <el-date-picker
                            v-model.trim="searchData['billTime']"
                            align="left"
                            value-format='yyyy-MM-dd HH:mm:ss'
                            unlink-panels
                            size="mini"
                            placeholder="单据时间"
                            ></el-date-picker>
                        </el-col>
                    </el-row>
                    <el-row v-if="showSecondQueryCondition">
                        <el-col class="sn-search-process-item"  v-for="(listItem,index) in searchList" :key='index'>
                            <div  class=" item secondHead">
                                <div class="search-label" :class='[listItem.type === "checkbox"?"isCheckbox":"notCheckbox"]'>{{listItem.label}}:</div>
                                <div class="search-code">
                                    <el-date-picker v-if="listItem.type === 'date'"
                                            v-model.trim="searchData[listItem.value]"
                                            align="left"
                                            value-format='yyyy-MM-dd HH:mm:ss'
                                            unlink-panels
                                            size="mini"
                                            :placeholder="listItem.label"
                                    ></el-date-picker>
                                    <el-input  v-else-if="listItem.type === 'input'" v-model.trim="searchData[listItem.value]" :placeholder="listItem.placeholder"></el-input>
                                    <el-checkbox v-else-if="listItem.type === 'checkbox'" v-model.trim="searchData[listItem.value]" true-label='1' false-label=''></el-checkbox>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col class="processSearchTotal-search-right">
                    <el-row type="flex" class="row-bg" justify="end">
                        <div class="search-margin">
                            <el-button type="primary" :loading="searchLoading" size="mini" @click="searchChange('isTrigger')" icon='el-icon-search'>
                                {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button class="sn-search-reset-button" @click="restSearchChange" size="mini">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                            <el-tooltip class="sn-search-default-button"  effect="dark" content="导出" placement="bottom">
                                <reportExport #default="{ submit }" reportCode="">
                                    <el-button icon="el-icon-upload2" size="mini" @click="searchExport(submit)"></el-button>
                                </reportExport>
                            </el-tooltip>
                            <div @click="changeSecondQueryCondition" class="packUP">
                                <span>{{isCloseText}}</span>
                                <span v-if="showSecondQueryCondition">
                                <i class="el-icon-arrow-up"></i>
                                </span>
                                <span v-else>
                                <i class="el-icon-arrow-down"></i>
                                </span>
                            </div>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="btnList">
            <el-button size="mini" type="primary" @click="batchOperation">
                {{$translate('lang.E3202301040034', { defaultText: '批量查询导出' })}}
            </el-button>
        </div>
        <div :class="isCloseFlag">
          <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :currentPage='currentPage'
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            :config="tableConfig">
        </m-table>
        </div>
        <el-dialog
            :title="$translate('lang.E3202301040034', { defaultText: '批量查询导出' })"
            :visible.sync="dialogVisible"
            width="600px"
            :before-close="handleClose">
            <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                :file-list="fileList"
                :auto-upload="false"
                :on-remove="handleRemove"
                :on-change="fileChange">
                <el-button size="small" type="primary">上传</el-button>
            </el-upload>
            <el-collapse value='1' class="processSearchTotal-collapse" >
                <el-collapse-item title="模板" name="1">
                    <mExport
                        :url='templateExport.exportUrl'
                        :params='templateExport.exportParams'
                        :name='templateExport.exportName'
                        :exportFlag='templateExport.exportFlag'
                        :type='templateExport.type'
                        :listData='listData'
                        :linkFlag="true"
                        :titleText='templateExport.titleText'>
                    </mExport>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <reportExport #default="{ submit }" reportCode="">
                    <el-button size="small" @click="exportListFile(submit)" type="primary">查询导出</el-button>
                </reportExport>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { searchLcbsProcessData, uploadProcess } from '../../../../../api/lcbsManagement.js';
import mTable from '../../../../../components/IdentityComponent/Main';
import { tableConfig } from './tableConfig.js';
import { searchListConfig } from './searchList.js';
import { searchByDictCodes } from '../../../../../api/systemManagementApi.js';
import mExport from '../../../component/export';
import reportExport from '@/components/lots/reportExportPlugin';
const EXPORT_API = '/api-sn/lbcs/barcodeFullProcessTracking/export'; // 通用导出接口路径
const OUTBOUND_INBOUND_TYPE = {// 出入库类型-对照
    'IN': '入库',
    'OUT': '出库'
};
const FIRE_SIZE = 1 * 1024 * 1024;// 文件大小1M
export default {
    props: {
        pageDescription: {
            type: String,
            default () {
                return '';
            }
        },
        billNosMain: {
            type: String,
            default () {
                return '';
            }
        }
    },
    components: { mTable, mExport, reportExport },
    data() {
        return {
            searchList: searchListConfig.searchList,
            tableConfig,
            searchData: {},
            searchLoading: false,
            listData: [],
            pageTotal: 0,
            currentPage: 1,
            showSecondQueryCondition: true,
            isCloseText: this.$translate('lang.E3202101280015', { defaultText: '收起' }),
            isCloseFlag: 'openStyle',
            templateFlie: {},
            fileList: [],
            dictObj: {},
            listExport: {
                exportUrl: '/api-sn/lbcs/barcodeFullProcessTracking/export',
                exportName: this.$translate('lang.E3202101280016', { defaultText: '条码全流程信息查询列表.xlsx' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260010', { defaultText: '导出Excel' }),
                exportFlag: 0
            },
            templateExport: {
                exportUrl: '/api-sn/lbcs/barcodeFullProcessTracking/templates/download',
                exportName: this.$translate('lang.E3202101280017', { defaultText: 'LBCS条码全流程批量查询模板.xlsx' }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260014', { defaultText: '批量查询模板下载' }),
                exportFlag: 1,
                type: 'get'
            },
            dialogVisible: false,
            listExportParams: {}
        };
    },
    methods: {
        handleDicts() {
            const params = {
                dictCodes: 'SN_LBCS_SHIP_ORG_TYPE,Y_N'
            };
            searchByDictCodes(params).then(res => {
                if (res && res.data) {
                    Object.keys(res.data).forEach(key => {
                        const obj = {};
                        res.data[key].forEach(item => {
                            obj[item.code] = item.name;
                        });
                        this.dictObj[key] = obj;
                    });
                }
            });
        },
        initData() {
            this.searchData = {
                barcodeNo: '',
                billNos: '',
                shipOrgName: '',
                recOrgName: '',
                customerCode: '',
                customerName: '',
                itemCode: '',
                itemName: '',
                buId: '',
                isShowRed: '',
                isReadTheEnd: ''
            };
        },
        restSearchChange() {
            this.initData();
        },
        changeSecondQueryCondition() {
            this.showSecondQueryCondition = !this.showSecondQueryCondition;
            if (this.showSecondQueryCondition) {
                this.isCloseText = this.$translate('lang.E3202101280015', { defaultText: '收起' });
                this.isCloseFlag = 'openStyle';
            } else {
                this.isCloseText = this.$translate('lang.E3202101280014', { defaultText: '展开' });
                this.isCloseFlag = 'closeStyle';
            }
        },
        handleSearchData() {
            const params = {
                ...this.searchData,
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize
            };
            if (params.billTime) {
                params['billBeginDate'] = params['billTime'];
                params['billEndDate'] = params['billTime'].substring(0, 10) + ' 23:59:59';
            };
            if (params.opTime) {
                params['opBeginDate'] = params['opTime'];
                params['opEndDate'] = params['opTime'].substring(0, 10) + ' 23:59:59';
            };
            if (params.prodTime) {
                params['prodBeginDate'] = params['prodTime'];
                params['prodEndDate'] = params['prodTime'].substring(0, 10) + ' 23:59:59';
            };
            delete params.billTime;
            delete params.opTime;
            delete params.prodTime;
            Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            if (params.billNos) {
                params.billNos = [params.billNos];
            }
            return params;
        },
        searchChange(isTrigger) {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            const params = this.handleSearchData();
            this.getData(params, isTrigger);
        },
        getData(params, isTrigger) {
            if (!params.barcodeNo && !params.billNos && !params.billBeginDate &&
            !params.opBeginDate && !params.prodBeginDate) {
                this.$message.warning(this.$translate('lang.EXC202101280001', { defaultText: '条码字符串、单据号、单据时间、扫码时间、生产时间不能同时为空' }));
                return;
            };
            this.listExportParams = JSON.parse(JSON.stringify(params));
            this.searchLoading = true;
            searchLcbsProcessData(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    const { SN_LBCS_SHIP_ORG_TYPE, Y_N } = this.dictObj;
                    this.listData.forEach(item => {
                        item.shipOrgTypeDict = SN_LBCS_SHIP_ORG_TYPE[item.shipOrgType];
                        item.recOrgTypeDict = SN_LBCS_SHIP_ORG_TYPE[item.recOrgType];
                        item.isEndDict = Y_N[item.isEnd];
                        item.inoutType = OUTBOUND_INBOUND_TYPE[item.inoutType];
                    });
                    this.pageTotal = res.data.totalCount;
                    if (res.data.list.length && isTrigger) {
                        this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                    }
                }
            }).finally(() => {
                this.searchLoading = false;
            });
        },
        fileChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xlsx' && testmsg !== 'xls') {
                this.$message({
                    message: this.$translate('lang.EXC202407010001', { defaultText: '表格上传类型不正确,仅支持上传xls，跟xlsx两种格式' }),
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
            }
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.$refs.upload.clearFiles();
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.currentPage = pageNo;
            const params = this.handleSearchData();
            this.getData(params);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.currentPage = 1;
            this.tableConfig.page.pageSize = pageSize;
            const params = this.handleSearchData();
            this.getData(params);
        },
        exportListFile(submit) {
            if (!this.templateFlie.name) {
                this.$message.warning('请先上传文件');
                return;
            }
            if (this.templateFlie.size > FIRE_SIZE) {
                this.$message.warning('文件大小不得超过1024KB，请修改后上传！');
                return;
            }
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            form.append('isReadTheEnd', this.searchData.isReadTheEnd);
            uploadProcess(form).then(res => {
                if (res && +res.code === 0) {
                    const params = {
                        EXPORT_API,
                        barcodeBatchNo: res.data
                    };
                    this.listExport.exportFlag = 1;
                    submit(params);
                    this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.templateFlie = {};
            this.listExport.exportFlag = 0;
            this.$refs.upload.clearFiles();
        },
        batchOperation() {
            this.dialogVisible = true;
        },
        searchExport(submit) {
            const params = {
                EXPORT_API,
                ...this.listExportParams
            };
            if (!params.barcodeNo && !params.billNos && !params.billBeginDate &&
            !params.opBeginDate && !params.prodBeginDate) {
                this.$message.warning(this.$translate('lang.EXC202101280001', { defaultText: '条码字符串、单据号、单据时间、扫码时间、生产时间不能同时为空' }));
                return;
            };
            if (!this.listData.length) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            };
            submit(params);
        }
    },
    mounted() {
        this.initData();
        this.handleDicts();
    }
};
</script>
<style lang="less" src='./index.less'>
</style>
